import { render } from "./WarningIcon.vue?vue&type=template&id=547c418d&scoped=true"
const script = {}

import "./WarningIcon.vue?vue&type=style&index=0&id=547c418d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-547c418d"]])

export default __exports__